import { Component, inject, Input, input, OnInit } from '@angular/core';
import { ParameterService, ViewState } from '@frontend/frontendlib';

@Component({
  selector: 'app-payment',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  
  @Input() mehr_text = '';
  parameterService = inject(ParameterService);
  ViewStateEnum: typeof ViewState = ViewState; 
  
  ngOnInit() {
    this.parameterService.init();
    this.parameterService.$fininishedLoading.subscribe((val) => {
      if (val) {
        this.parameterService.init_state();
      }
    });
  }
}
